import React, { useContext, useState } from "react";
import "../assets/css/--component-header.css";
import logo from "../assets/images/mains-logo.png";
import profileIcon from "../assets/images/profile-icon.png";
import cartIcon from "../assets/images/cart.png";
import phoneIcon from "../assets/images/phone-icon.png";
import locationIcon from "../assets/images/location-icon.png";
import CartDrawer from "./CartDrawer";
import { useCart } from "../context/cartProvider";
import { GlobalContext } from "../context";
import LocationModal from "./LocationModal";
import { Link, useNavigate, useLocation } from "react-router-dom";

const PHONE_NUMBER_TEL = "+18608875509";

const Header = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [cartItem, setCartItems] = useState({});
  const { openCart } = useCart();
  const { cartCount } = useContext(GlobalContext);
  // const [locationModalOpen, setLocationModalOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const toggleSearch = () => {
    setSearchOpen(!searchOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  const _setCartItem = (items) => {
    setCartItems(items);
  };

  const history = useNavigate();

  const location = useLocation();

  const preventSameRoute = (e, path) => {
    if (location.pathname === path) {
      e.preventDefault();
    }
  };

  // const toggleLocationModal = () => {
  //   setLocationModalOpen(!locationModalOpen);
  // };

  return (
    <>
      <section id="mains-header">
        <div className="wrapper">
          {/* Mobile Search Bar - Slides from top */}
          {/* <div className={`mobile-search-container ${searchOpen ? "active" : ""}`}>
            <div className="mobile-search-bar">
              <input type="text" placeholder="Search for menu items..." autoFocus />
              <button className="close-search-btn" onClick={toggleSearch}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </div>
          </div> */}

          <header className="header">
            <div className="logo-wrapper">
              <img src={logo} alt="Main's Logo" onClick={() => history("/")} />
            </div>

            {/* Mobile Icons Container */}
            <div className="mobile-icons">
              <div className="sidebar-icons">
                <span
                  className="cart-length-box"
                  onClick={() => {
                    openCart();
                    closeSidebar();
                  }}
                >
                  <img src={cartIcon} alt="Main's" />
                  <span className="cart-length-show">{cartCount.CartItemCount || 0}</span>
                </span>
                <img src={profileIcon} alt="Main's" onClick={() => history("/login")} />
              </div>
              {/* Mobile Search Icon */}
              {/* <button className="mobile-search-btn" onClick={toggleSearch}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
              </button> */}

              {/* Mobile Hamburger Menu Button */}
              <button className="hamburger-btn" onClick={toggleSidebar}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="3" y1="12" x2="21" y2="12"></line>
                  <line x1="3" y1="6" x2="21" y2="6"></line>
                  <line x1="3" y1="18" x2="21" y2="18"></line>
                </svg>
              </button>
            </div>

            <div className="header-right">
              <div className="top-header">
                <div className="top-left">
                  {/* <div className="mains-search">
                    <input type="text" placeholder="Search..." />
                    <span className="search-icon">
                      <svg
                        className="menu-search-icon"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="20"
                        height="20"
                        fill="rgba(26,26,26,1)"
                      >
                        <path d="M18.031 16.6168L22.3137 20.8995L20.8995 22.3137L16.6168 18.031C15.0769 19.263 13.124 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20 13.124 19.263 15.0769 18.031 16.6168ZM16.0247 15.8748C17.2475 14.6146 18 12.8956 18 11C18 7.1325 14.8675 4 11 4C7.1325 4 4 7.1325 4 11C4 14.8675 7.1325 18 11 18C12.8956 18 14.6146 17.2475 15.8748 16.0247L16.0247 15.8748Z"></path>
                      </svg>
                    </span>
                  </div> */}

                  <div className="location">
                    <img src={locationIcon} alt="Main's" />
                    <a href="https://share.google/9lqJRYSi6i52639Km" className="title" target="_blank" rel="noopener noreferrer">
                      Find Main's
                    </a>
                  </div>
                </div>

                <div className="contact-section">
                  <a href={`tel:${PHONE_NUMBER_TEL}`} className="contact-icon">
                    <img src={phoneIcon} width={24} height={24} alt="Main's" />
                    <span>(860)-887-5509</span>
                  </a>

                  <Link to="/menu" className="contact-btn">
                    ORDER NOW
                  </Link>
                </div>
              </div>
              <span className="separator-line my-3" />
              <div className="bottom-header">
                <nav className="nav">
                  <Link to="/" onClick={(e) => preventSameRoute(e, "/")}>
                    HOME
                  </Link>

                  <Link to="/menu" onClick={(e) => preventSameRoute(e, "/menu")}>
                    OUR MENU
                  </Link>

                  <Link to="/store" onClick={(e) => preventSameRoute(e, "/store")}>
                    STORE ITEMS
                  </Link>

                  <Link to="/special" onClick={(e) => preventSameRoute(e, "/special")}>
                    SPECIALS
                  </Link>

                  <Link to="/about-us" onClick={(e) => preventSameRoute(e, "/about-us")}>
                    ABOUT US
                  </Link>

                  <Link to="/contact" onClick={(e) => preventSameRoute(e, "/contact")}>
                    CONTACT US
                  </Link>
                </nav>

                <div className="nav-icons">
                  <span className="cart-length-box" onClick={openCart}>
                    <img src={cartIcon} alt="Main's" />
                    <span className="cart-length-show">{cartCount.CartItemCount || 0}</span>
                  </span>
                  <img src={profileIcon} alt="Main's" onClick={() => history("/login")} />
                </div>
              </div>
            </div>
          </header>
        </div>
      </section>

      {/* Mobile Sidebar */}
      <div className={`mobile-sidebar-overlay ${sidebarOpen ? "active" : ""}`} onClick={closeSidebar}></div>
      <div className={`mobile-sidebar ${sidebarOpen ? "active" : ""}`}>
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <img src={logo} alt="Main's Logo" />
          </div>
          <button className="close-sidebar" onClick={closeSidebar}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <nav className="sidebar-nav">
          <Link
            to="/"
            onClick={(e) => {
              preventSameRoute(e, "/");
              closeSidebar();
            }}
          >
            HOME
          </Link>

          <Link
            to="/menu"
            onClick={(e) => {
              preventSameRoute(e, "/menu");
              closeSidebar();
            }}
          >
            OUR MENU
          </Link>

          <Link
            to="/store"
            onClick={(e) => {
              preventSameRoute(e, "/store");
              closeSidebar();
            }}
          >
            STORE ITEMS
          </Link>

          <Link
            to="/special"
            onClick={(e) => {
              preventSameRoute(e, "/special");
              closeSidebar();
            }}
          >
            SPECIALS
          </Link>

          <Link
            to="/about-us"
            onClick={(e) => {
              preventSameRoute(e, "/about-us");
              closeSidebar();
            }}
          >
            ABOUT US
          </Link>

          <Link
            to="/contact"
            onClick={(e) => {
              preventSameRoute(e, "/contact");
              closeSidebar();
            }}
          >
            CONTACT US
          </Link>
        </nav>

        <div className="sidebar-location">
          <img src={locationIcon} alt="Main's" />
          <a href="https://share.google/9lqJRYSi6i52639Km" className="title" target="_blank" rel="noopener noreferrer">
            Find Main's
          </a>
        </div>

        <div className="sidebar-footer">
          <a href={`tel:${PHONE_NUMBER_TEL}`} className="contact-icon">
            <img src={phoneIcon} width={24} height={24} alt="Main's" />
            <span>(860)-887-5509</span>
          </a>
          <Link
            to="/menu"
            className="sidebar-contact-btn"
            onClick={(e) => {
              preventSameRoute(e, "/menu");
              closeSidebar();
            }}
          >
            ORDER NOW
          </Link>
        </div>
      </div>

      <CartDrawer cartItemCount={_setCartItem} />
      {/* {locationModalOpen && <LocationModal isOpen={locationModalOpen} toggle={toggleLocationModal} />} */}
    </>
  );
};

export default Header;
